import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const { t, i18n } = useTranslation('common');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  const navItems = [
    { key: 'services', href: '#services' },
    { key: 'process', href: '#process' },
    { key: 'universities', href: '#universities' },
    { key: 'testimonials', href: '#testimonials' },
    { key: 'faq', href: '#faq' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="flex items-center cursor-pointer" onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            if (window.location.pathname !== '/') {
              window.REACT_APP_NAVIGATE('/');
            }
          }}>
            <span className="text-2xl font-bold text-teal-600">AfricaStudyUSA</span>
          </a>

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={item.href}
                className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
              >
                {t(`nav.${item.key}`)}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="#contact"
              className="inline-flex items-center rounded-full bg-teal-600 px-6 py-3 text-sm font-semibold text-white shadow-md hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('nav.contact')}
            </a>
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <i className="ri-global-line text-xl text-gray-700 w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm font-semibold text-gray-700">
                {i18n.language === 'fr' ? 'FR' : 'EN'}
              </span>
            </button>
          </div>

          <button
            className="lg:hidden text-gray-700 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl w-8 h-8 flex items-center justify-center`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="flex flex-col space-y-4 px-6 py-6">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={item.href}
                className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                {t(`nav.${item.key}`)}
              </a>
            ))}
            <a
              href="#contact"
              className="inline-flex items-center justify-center rounded-full bg-teal-600 px-6 py-3 text-sm font-semibold text-white shadow-md hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('nav.contact')}
            </a>
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer w-fit"
            >
              <i className="ri-global-line text-xl text-gray-700 w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm font-semibold text-gray-700">
                {i18n.language === 'fr' ? 'FR' : 'EN'}
              </span>
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
